import React from "react"

import { useTrialBlock } from "@/contexts/TrialBlockContext"

import TrialBlockReviewForm from "./TrialBlockReviewForm"

const TrialBlockReviewDialog: React.FC = () => {
  const { selectedBlock, blocks, handleReviewSubmit, setSelectedBlock } = useTrialBlock()

  if (!selectedBlock) return null

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onReviewSubmit = (id: string, formData: any) => {
    handleReviewSubmit(id, formData)
  }

  const onCancel = () => {
    setSelectedBlock(null)
  }

  return (
    <TrialBlockReviewForm
      shift={blocks.find((s) => s.id === selectedBlock)!}
      onCancel={onCancel}
      onSubmit={(formData) => onReviewSubmit(selectedBlock, formData)}
    />
  )
}

export default TrialBlockReviewDialog
